export default {
    /* GET_DAILY_REPORTS_SHIFT_SUMMARIES_REPORTS
    ---------------------------------------------------------------
    */
    GET_DAILY_REPORTS_SHIFT_SUMMARIES_REQUEST: state => {
        state.dailyReportsShiftSummariesLoading = true
    },
    GET_DAILY_REPORTS_SHIFT_SUMMARIES_SUCCESS: (state, data) => {
        state.dailyReportsShiftSummaries = data.results
        state.dailyReportsShiftSummariesLoading = false
    },
    GET_DAILY_REPORTS_SHIFT_SUMMARIES_FAILURE: state => {
        state.dailyReportsShiftSummariesLoading = false
    },

    GET_DAILY_SHIPMENTS_REPORTS_SHIFT_SUMMARIES_REQUEST: state => {
        state.dailyReportsShiftSummariesLoading = true
    },
    GET_DAILY_SHIPMENTS_REPORTS_SHIFT_SUMMARIES_SUCCESS: (state, data) => {
        state.dailyReportsShiftSummaries = data.results
        state.dailyReportsShiftSummariesLoading = false
    },
    GET_DAILY_SHIPMENTS_REPORTS_SHIFT_SUMMARIES_FAILURE: state => {
        state.dailyReportsShiftSummariesLoading = false
    },


    SET_DAILY_REPORTS_SHIFT_SUMMARIES_FILTERS: (state, filters) => {
        state.dailyReportsShiftSummariesFilters = filters
    },
    CLEAR_DAILY_REPORTS_SHIFT_SUMMARIES_FILTERS: state => {
        state.dailyReportsShiftSummariesFilters = state.setInitialDailyReportsShiftSummariesFilters()
    },
    CLEAR_DAILY_REPORTS_SHIFT_SUMMARIES: state => {
        state.dailyReportsShiftSummaries = []
    },
    SET_USER: (state, data) => {
        state.user = data
    },
    CLEAR_USER: state => {
        state.user = null
    }
}